import http from '@/http'
const URL = '/admin'

export const login = (payload) => http.post(URL + '/auth/login', payload)
export const logout = (payload) => http.post(URL + '/auth/logout', payload)
export const loadSession = () => http.get(URL + '/settings/me')
export const ssoAuthenticate = (payload) => http.post('/sso/authenticate', payload)

export default {
  login,
  logout,
  loadSession,
  ssoAuthenticate
}
